const BOM = '﻿'

export interface DownloadCsvOptions {
  content: string
  fileName: string
  withBom: boolean
}

export const downloadCsv = ({
  content,
  fileName,
  withBom,
}: DownloadCsvOptions): void => {
  const parts = withBom ? [BOM, content] : [content]
  const blob = new Blob(parts, { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')

  link.setAttribute('href', url)
  link.setAttribute('download', fileName)
  link.style.visibility = 'hidden'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
